// Note: If you change this, remember to also change it in services repo!
export const FOCUS_TIME_IDEAL_MINUTES_DEFAULT: number = 900;
